import { ButtonIcon } from '@qualtrics/ui-react/icons';
import {
  logNavigation,
  navigateAfterEnterClick,
} from '../../../Service/navigation-service';
import { MenuItem } from '@qualtrics/ui-react';
import classNames from 'classnames';
import styles from './switcherTab.scss';
import { messageService } from '../../../Service/message-service';
import React from 'react';
import { iconsMapping } from './iconsMapping';
import { newTabs } from './newTabsList';
import { Indicator } from '@qualtrics/ui-react/next';

export const getSwitcherTab = (section, tabConfig) => {
  const { activeSuperTab, areNewTagsEnabled, newTagLabel, isMobileView } =
    tabConfig || {};
  const ContextIcon = iconsMapping[section.contextType] || ButtonIcon;
  const activeContextType =
    activeSuperTab?.highlightContextType ?? activeSuperTab?.v2Info?.contextType;
  const isActive = section.contextType === activeContextType;

  const handleSelect = (e, section) => {
    logNavigation(section, false);
    navigateAfterEnterClick(e, section.href);
  };

  return (
    <MenuItem
      key={section.contextType}
      className={classNames(styles.menuOption, {
        [styles.menuActiveOption]: isActive,
        [styles.menuOptionSmallScreens]: isMobileView,
      })}
      label={messageService.get(section.nameKey)}
      value={section.contextType}
      onSelect={(e) => handleSelect(e, section)}
      data-testid={'gw-supertab-' + section.nameKey}
      data-active={isActive || null}
      aria-current={isActive ? true : undefined}
    >
      <a
        href={section.href}
        className={classNames(styles.menuOptionName, {
          [styles.menuActiveOptionName]: isActive,
        })}
      >
        <ContextIcon
          aria-hidden
          className={classNames(styles.menuOptionIcon, {
            [styles.menuActiveOptionIcon]: isActive,
          })}
        />
        <span className={styles.menuOptionText}>
          {messageService.get(section.nameKey)}
        </span>
        {areNewTagsEnabled && newTabs.includes(section.contextType) && (
          <div className={styles.newTabIndicatorWrapper}>
            <Indicator variant="informational" hideIcon>
              {newTagLabel}
            </Indicator>
          </div>
        )}
      </a>
    </MenuItem>
  );
};
